import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerSuccessService,
  type Wealthlane_CustomerService_Dtos_CustomerSuccess_ParticipantSearchResultDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useSearchParticipants = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  companyId?: string,
  query?: string,
  enabled: boolean = true
): UseQueryResult<
  Wealthlane_CustomerService_Dtos_CustomerSuccess_ParticipantSearchResultDto[] | undefined,
  unknown
> => {
  return useQuery(
    ['searchParticipants', companyId, query],
    async () => {
      return await handleRequest(
        CustomerSuccessService.getApiCustomerApiCustomerCustomerSuccessParticipantsSearch(
          companyId,
          query
        )
      );
    },
    {
      enabled: enabled && (query === undefined || query.length >= 2),
      keepPreviousData: true,
    }
  );
};

export default useSearchParticipants;
